// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8f66a22e","154":"7b24c2c5","248":"bf449330","374":"29e8dcf3","419":"d16a53ab","599":"078426ac","772":"34c02786","898":"7b8e37ac","941":"3304906d","951":"e339c7e2"}[chunkId] + ".chunk.js";
};